import { Component, input, output } from '@angular/core';
import type { DailyFact } from '../../services/daily-facts.service';
import { DailyFactHeroComponent } from '../daily-fact-hero/daily-fact-hero.component';
import { DailyFactStatusBadgeComponent } from '../daily-fact-status-badge/daily-fact-status-badge.component';
import { DailyFactActionsComponent } from '../daily-fact-actions/daily-fact-actions.component';
import { AdminDataTableComponent } from '../../../../../shared/components/admin-data-table/admin-data-table.component';
import type { AdminTableColumn } from '../../../../../shared/components/admin-data-table/admin-table-column.interface';

@Component({
  selector: 'app-daily-facts-table',
  standalone: true,
  imports: [
    DailyFactHeroComponent,
    DailyFactStatusBadgeComponent,
    DailyFactActionsComponent,
    AdminDataTableComponent,
  ],
  templateUrl: './daily-facts-table.component.html',
  styleUrl: './daily-facts-table.component.scss',
})
export class DailyFactsTableComponent {
  facts = input.required<DailyFact[]>();
  getVideoStatusLabel = input.required<(s: string | null | undefined) => string>();
  getVideoStatusClass = input.required<(s: string | null | undefined) => string>();
  canReviewVideo = input.required<(f: DailyFact) => boolean>();
  isGenerating = input.required<(id: string) => boolean>();

  generateVideo = output<DailyFact>();
  reviewVideo = output<DailyFact>();

  readonly columns: AdminTableColumn[] = [
    { id: 'hero', headerKey: 'app.admin.dailyFacts.hero', thClass: 'col-hero' },
    { id: 'date', headerKey: 'app.admin.dailyFacts.date' },
    { id: 'category', headerKey: 'app.admin.dailyFacts.category' },
    { id: 'fact', headerKey: 'app.admin.dailyFacts.fact' },
    {
      id: 'videoStatus',
      headerKey: 'app.admin.dailyFacts.videoStatus',
      thClass: 'col-center',
    },
    {
      id: 'actions',
      headerKey: 'app.admin.dailyFacts.actions',
      thClass: 'col-center col-actions',
    },
  ];

  readonly trackFact = (fact: DailyFact): string => fact.id;
}
